import { requestGet } from '@/utils/request';

// 获取华为云临时上传文件链接
export function submitFile(params: { path: string; fileName: string; contentType: string }) {
  return requestGet(`/fcoin/api/file/upload/temporary/url`, params);
}
